var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeClosed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_64_1",
    "data-name": "Component 64 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_hide_pass"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 22,
    height: 23,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer",
    transform: "translate(1.04 7.314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_109",
    "data-name": "Vrstva 109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M20.951,11.5l-.789-1.361a3.68,3.68,0,0,0,.244-.319l.122-.169V9.6h0L20.209,9.4,19.8,9.077l.441.291.319.207a.943.943,0,0,0-1.577-1.033h0l-.094.122c-.085.122-.207.282-.376.488a12.206,12.206,0,0,1-1.53,1.53,8.948,8.948,0,0,1-5.633,2.131,8.948,8.948,0,0,1-5.633-2.131A12.206,12.206,0,0,1,4.173,9.19,3.638,3.638,0,0,1,3.835,8.7L3.741,8.58h0A.943.943,0,1,0,2.163,9.613L2.9,9.134l-.732.479h0V9.66l.122.169.094.131L1.44,11.509a.939.939,0,1,0,1.624.939l.592-1.023c.244.235.507.479.807.723a12.487,12.487,0,0,0,1.418,1l-.638,1.174a.939.939,0,1,0,1.624.939l.723-1.286a10,10,0,0,0,2.817.676h0v.939a.939.939,0,0,0,1.878,0v-.939h0a10.234,10.234,0,0,0,2.6-.6l.695,1.211a.939.939,0,1,0,1.624-.939l-.62-1.08a12.271,12.271,0,0,0,1.606-1.1c.235-.188.441-.385.648-.563l.5.864a.939.939,0,1,0,1.624-.939Z",
    transform: "translate(-1.294 -8.116)",
    fill: "rgba(0,0,0,0.8)"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ic_show_pass",
    transform: "translate(1.637 2)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66970",
    "data-name": "Path 66970",
    d: "M1.5,12.81S4.9,6,10.863,6s9.363,6.81,9.363,6.81-3.4,6.81-9.363,6.81S1.5,12.81,1.5,12.81Z",
    transform: "translate(-1.5 -6)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66971",
    "data-name": "Path 66971",
    d: "M18.607,16.054A2.554,2.554,0,1,1,16.054,13.5,2.554,2.554,0,0,1,18.607,16.054Z",
    transform: "translate(-6.69 -9.244)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eye_closed.9e499347d3a7eaf6d4658e47d291548e.svg";
export { ForwardRef as ReactComponent };